import React, { useEffect } from 'react'
import { Divider } from 'semantic-ui-react'
import RecentSection from './RecentSection'
import PipelineCharts from './PipelineCharts'
import { useDispatch } from 'react-redux';
import pipelineActions from 'actions/pipeline';
import { useSearchParams } from 'react-router-dom';

export default function SalesDashboard({ startTime, endTime }) {

  const [params] = useSearchParams();

  const startParams = params.get("start")
  const endParams = params.get("end")
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(pipelineActions.getPipelineCategories({ account_stage: "lead" }));
    dispatch(pipelineActions.getPipelineCategoriesForOpportunity({ account_stage: "opportunity" }));
  }, [dispatch])
  return (
    <React.Fragment>
      <PipelineCharts startTime={startParams || startTime} endTime={endParams || endTime} />
      <Divider />
      <RecentSection />
    </React.Fragment>
  )
}
